
import React, { useEffect,useRef, useMemo, useState } from "react";
import Notify from "../../lib/Utils/Alert";
import {
    Col,
    Button,
    Modal,
    DropdownButton,
    Dropdown,
    Table
} from "react-bootstrap";
import {Form, FormGroup,Label,Input} from "reactstrap"
import './Setting.css';
import FileUpload from "lib/Core/Backend/Controllers/FileUpload";
import { Link } from 'react-router-dom';
import ReactNotificationAlert from 'react-notification-alert';
import Purchaser from "lib/Core/Backend/Controllers/Purchaser";
// import { Input } from "reactstrap";
import Select from 'react-select';
import Spinner from 'react-bootstrap/Spinner';

function Setting(props) {
    const { token } = props
    const purchaserCtl = useMemo(() => new Purchaser(token), [token]);
    const [uploadModal, setUploadModal] = useState(false)
    const [uploadModalTwo, setUploadModalTwo] = useState(false)
    const [docTerms, setDocTerms] = useState(null)
    const [docPrivacy, setDocPrivacy] = useState(null)
    const [fileNameTwo, setFileNameTwo] = useState('');
    const [fileName, setFileName] = useState("");
    const [selectedFileTwo, setSelectedFileTwo] = useState(null);
    const [selectedFile, setSelectedFile] = useState(null);
    const supplierCtl = useMemo(() => new FileUpload(token), [token]);
    const alert = useRef(null);
    const [notificationModal,setNotificationModal] = useState(false)
    const [selectedNotification, setSelectedNotification] = useState(null);
    const [notificationValue,setNotifictionValue] = useState(null);
    const [notificationData,setNotificationData] = useState([])
    const [warningModal,setWarningModal] = useState(false);
    const [email, setEmail] = useState(null);
    const [addNotiLoad, setAddNotiLoad]= useState(false)
    const [loader,setLoader] = useState(true)
    const toggleWarning = () => setWarningModal(!warningModal);

    const handleNotificationChange = (selectedOption) => {
        const option = selectedOption?.value
        setSelectedNotification(selectedOption);
        setNotifictionValue(option)
    };
const closeNotificationModal = () =>{
    setNotificationModal(false)
    setSelectedNotification([])
    setEmail(null)
}

const openNotificationModal = () =>{
    setNotificationModal(true)
}
    
const getNotifydetails = () =>{
    purchaserCtl.notification((data)=>{
        if(data && !data.error){
        setNotificationData(data)
        setLoader(false)
        }else{
        setLoader(false)
        }
        })
}
    useEffect(()=>{
        getNotifydetails()
    },[])
   
      const addNotificationLoading=()=>{
        setTimeout(()=>{
            setAddNotiLoad(false)
          }, 1500)
      }

    const handleSubmit = () => {
        setAddNotiLoad(true)
        if(notificationValue === undefined || notificationValue === null){
            Notify(alert,"warning","Please select Notification Type")
            addNotificationLoading()
            return;
        }

        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;


         if(email === undefined || email === null){
            Notify(alert, "warning", "Enter field can not be empty")
            addNotificationLoading()
            return;
           }
          if (!emailRegex.test(email)) {
            Notify(alert, "warning", "Enter valid email adress")
            addNotificationLoading()
            return 
            
          }

        let obj ={
            email:email,
            type:notificationValue
        }
    
        purchaserCtl.postNotification(obj,(data)=>{
            if(data?.status === 403){
                toggleWarning();
                addNotificationLoading()
                setNotificationModal(false)
                return;
            }
          if(data && !data.error){
     
            setNotificationModal(false)
            Notify(alert,"success",` Add Notification for ${data?.message} successfully`)
            addNotificationLoading()
            getNotifydetails()
          }else{
            Notify(alert,"danger",data?.errorMessage)
            addNotificationLoading()
          }
        })
    };

    const notificationOptions = [
        { value: 'OPEN', label: 'Order open alert' },
        { value: 'ON_HOLD', label: 'Low funds order' },
        { value: 'NON_API', label: 'Manual fulfillment' },
        { value: 'FUND_INVOICE', label:'Payment invoice'},
        { value: 'QUICK_BOOK', label: 'Order report'},
        { value: 'INVENTORY_REPORT', label: 'Inventory report'},
        { value:'LOW_FUND_ALERT', label:'Low fund alert'},
        { value:'PENDING_APPROVAL', label:'Pending Approval'},
        { value:'OUT_OF_STOCK', label:'Out Of Stock'}
    ];


    const getDocument = () => {
        supplierCtl.getPDFDocument((data) => {
            if (data && !data.error) {
                const filteredTerms = data?.filter(term => term.active && term.type === "TERMS");
                setDocTerms(filteredTerms.length === 0 ? null : filteredTerms);
                const filteredPrivacy = data?.filter(term => term.active && term.type === "PRIVACY");
                setDocPrivacy(filteredPrivacy.length === 0 ? null : filteredPrivacy)
            }
            else {
                Notify(alert, "danger", data?.errorMessage ?? data?.error)
            }
        })
    }
    const downloadTermsandCondition = (url) => {
        const link = Object.assign(document.createElement('a'), { href: url, download: '', target: '_blank' });
        document.body.appendChild(link).click();
        document.body.removeChild(link);
    };

    const downloadFile = (FileType) => {
        supplierCtl.downloadPDFDocument(FileType, (data) => {
            if(data?.status === 403){
                toggleWarning()
                return;
            }
            if (data && !data.error) {
                downloadTermsandCondition(data?.link)
            } else {
                Notify(alert, "danger", data?.errorMessage ?? data?.error)
            }
        })
    }
    const deleteFile = (documentType, uuid) => {

        supplierCtl.deletePDFDocument(documentType, uuid, (data) => {
            if(data?.status === 403){
                toggleWarning()
                return;
            }
            if (data && !data.error) {
                Notify(alert, "success", 'Deleted successfully');
                getDocument()
            } else {
                Notify(alert, "danger", data?.errorMessage ?? data?.error)
            }
        })
    };
    const closeUploadModal = () => {
        setUploadModal(false)
        setFileName("")
    }
    const closeUploadModalTwo = () => {
        setUploadModalTwo(false)
        setFileNameTwo("")
    }
    const handleFileprivacy = (event) => {
        setFileNameTwo(event?.target?.files[0]?.name);
        setSelectedFileTwo(event.target.files[0]);
    }
    const handleFileTerms = (event) => {
        setFileName(event?.target?.files[0]?.name)
        setSelectedFile(event.target.files[0]);
    };
    const [upTermsName, setUpTermsName] = useState(null)
    const [upPrivacyName, setUpPrivacyName] = useState(null)
    const uploadFile = (FileType, name) => {
        if (FileType == "TERMS") {
            setUploadModal(true)
            setUploadModalTwo(false)
            setUpTermsName(name)
        } else {
            setUploadModal(false)
            setUploadModalTwo(true)
            setUpPrivacyName(name)
        }
    }
    const uploadDocumentTerms = () => {
        const file = selectedFile;
        const fileSizeMB = file.size / (1024 * 1024);
        if (fileSizeMB > 10) {
            Notify(alert, "danger", 'File size must be lesser than 10MB');
            return;
        }
        supplierCtl.uploadPDFDocument('TERMS', file, (data) => {
            if(data?.status === 403){
                toggleWarning()
                setUploadModal(false)
                return;
            }
            if (data && !data?.error) {
                Notify(alert, "success", 'Uploaded successfully');
                setUploadModal(false)
                setFileName("")
                if (docTerms === null) {
                    getDocument()
                }
                else {
                    const index = docTerms.findIndex(
                        (item) => item.name === upTermsName
                    );
                    if (index !== -1) {
                        docTerms[index] = data
                        getDocument()
                       
                    }
                }
            } else {
                if(data?.errorMessage.includes("could not execute statement; SQL [n/a];")){
                    Notify(alert,"danger","Please Upload a Valid File!")
                }else{
                    Notify(alert, "danger", data?.errorMessage ?? data?.error )
                }
               
            }
        })
    }
    const uploadDocumnetPrivacy = () => {
        const file = selectedFileTwo
        const fileSizeMB = file.size / (1024 * 1024);
        if (fileSizeMB > 10) {
            Notify(alert, "danger", 'File size must be lesser than 10MB');
            return;
        }
        supplierCtl.uploadPDFDocument('PRIVACY', file, (data) => {
            if(data?.status === 403){
                toggleWarning();
                setUploadModalTwo(false);
                return;
            }
            if (data && !data.error) {
                Notify(alert, "success", 'Uploaded successfully');
                setUploadModalTwo(false)
                setFileNameTwo("")
                if (docPrivacy === null) {
                    getDocument()
                }
                else {
                    const index = docPrivacy.findIndex(
                        (item) => item.name === upPrivacyName
                    );
                    if (index !== -1) {
                        docPrivacy[index] = data
                        getDocument()
                        
                    }
                }
                
            } else {
                if(data?.errorMessage.includes("could not execute statement; SQL [n/a];")){
                    Notify(alert,"danger","Please Upload a Valid File!")
                }else{
                    Notify(alert, "danger", data?.errorMessage ?? data?.error )
                }
            }
        })
    }
    const convertToEST = (timestamp) => {
        const date = new Date(timestamp);
        const options = {
            timeZone: 'America/New_York',
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        };
        return date.toLocaleString('en-US', options);
    }

    useEffect(() => {
        getDocument()
        return () => {
            setDocTerms(null)
            setDocPrivacy(null)
        };

    }, []);

    

    const DeleteNotification = (delID,delType) =>{
        
        if(delID && delID !== undefined){
            purchaserCtl.delNotification(delID,delType,(data)=>{
                if(data?.status === 403){
                    toggleWarning()
                    return;
                }
                if(data && !data.error){
                    Notify(alert,"success","Notification Delete Successfully");
                    getNotifydetails()

                }
            })
        }
    }

    const typeMapping = {
        On_hold: "Low funds order",
        Non_api: "Manual fulfillment",
        Open: "Order open alert",
        Fund_invoice: "Payment invoice",
        Quick_books: "Order report",
        Pending_approval: "Pending approval",
        Inventory_reports: "Inventory report"
    };

    const getNotificationTypeAndEmail = (data) => {
        return Object.keys(data).map(key => ({
            type: key,
            email: data[key].email,
            id: data[key].id
        }));
    };

    const processedData = notificationData.flatMap(item => getNotificationTypeAndEmail(item));

  
    return (
        <>
            <ReactNotificationAlert ref={alert} />
            <div className="top_doc mx-3 custom_table_settings">
                <div className="custom-container shadow-sm">
                <h1 className=" text-dark font_style">Document</h1>
                <div className="table-responsive">
                    <Table className="table table_style unique">
                        <thead className='bg-light-red font-14 static-header'>
                                <th className="document-column table-header">Document</th>
                                <th className="file-name-column table-header">File Name</th>
                                <th className="last-updated-column table-header">Last Updated On</th>
                                <th className="action-column table-header">Action</th>
                        </thead>
                        <tbody>
                            {docTerms === null && (
                                <tr>
                                    <td className="font14 fw-medium">Terms and Conditions</td>
                                    <td className="font14 fw-medium">
                                        <a> {"no file is uploaded"}
                                        </a>
                                    </td>
                                    <td>{new Date().toLocaleDateString('en-US', { timeZone: 'America/New_York' })}</td>
                                    <td className='svg_style text-center pointer'>
                                        <DropdownButton
                                            variant="white"
                                            className="p-0 tableActionDropDown text-center"
                                            title={
                                                <div className="actionBtn">
                                                    {[...Array(3)].fill().map((_, index) => <span key={index}>
                                                        <i className="bi bi-three-dots-vertical"></i></span>)}
                                                </div>
                                            }
                                            drop="start"
                                        >
                                            <div>
                                                <Dropdown.Item
                                                    className="font14 fw-medium" style={{borderRadius:"30px"}}
                                                    onClick={() => {
                                                        uploadFile('TERMS')
                                                    }}
                                                >
                                                    Upload
                                                </Dropdown.Item>
                                               
                                            </div>
                                        </DropdownButton>
                                    </td>
                                </tr>
                            )}

                            {docTerms?.map((terms, index) =>
                                <tr key={index}>
                                    <td className="font14 fw-medium">Terms of Use</td>
                                    <td className="font14 fw-medium" onClick={(e) => { e.preventDefault(); downloadFile('TERMS')}}>
                                        <Link to={`#${terms.name}`} target="_blank">{terms.name}</Link>
                                    </td>
                                    <td>{convertToEST(terms.updatedAt)}</td>
                                    <td className='svg_style text-center pointer'>
                                        <DropdownButton
                                        style={{color:"red"}}
                                            variant="white"
                                            className="p-0 tableActionDropDown text-center"
                                            title={
                                                <div className="actionBtn">
                                                    {[...Array(3)].fill().map((_, index) => <span key={index}>
                                                        <i className="bi bi-three-dots-vertical"></i></span>)}
                                                </div>
                                            }
                                            drop="start"
                                        >
                                            <div className="auto-max-height bg-white">
                                                <Dropdown.Item
                                                    className="font14 fw-medium"
                                                    style={{color:"red"}}
                                                    onClick={() => {
                                                        uploadFile('TERMS', `${terms.name}`)
                                                    }}
                                                >
                                                    Upload
                                                </Dropdown.Item>
                                                <Dropdown.Item
                                                    className="font14 fw-medium"
                                                    onClick={() => {
                                                        downloadFile('TERMS')
                                                    }}
                                                >
                                                    Download
                                                </Dropdown.Item>
                                                <Dropdown.Item
                                                    className="font14 fw-medium"
                                                    onClick={() => {
                                                        deleteFile('TERMS', `${terms.name}`)
                                                    }}
                                                >
                                                    Delete
                                                </Dropdown.Item>
                                            </div>
                                        </DropdownButton>
                                    </td>
                                </tr>)}
                            {docPrivacy === null && (
                                <tr>
                                    <td className="font14 fw-medium">Privacy Policy</td>
                                    <td className="font14 fw-medium">
                                        <a>{"no file is uploaded"}</a></td>
                                    <td>{new Date().toLocaleDateString('en-US', { timeZone: 'America/New_York' })}</td>
                                    <td className='svg_style text-center pointer'>
                                        <DropdownButton
                                            variant="white"
                                            className="p-0 tableActionDropDown text-center"
                                            title={
                                                <div className="actionBtn">
                                                    {[...Array(3)].fill().map((_, index) => <span key={index}>
                                                        <i className="bi bi-three-dots-vertical"></i></span>)}
                                                </div>
                                            }
                                            drop="start"
                                        >
                                            <div className="auto-max-height">
                                                <Dropdown.Item
                                                    className="font14 fw-medium"
                                                    onClick={() => {
                                                        uploadFile('PRIVACY')
                                                    }}
                                                >
                                                    Upload
                                                </Dropdown.Item>
                                            </div>
                                        </DropdownButton>
                                    </td>
                                </tr>
                            )}
                            {docPrivacy?.map((terms, index) =>
                                <tr key={index}>
                                    <td className="font14 fw-medium">Privacy Policy</td>
                                    <td className="font14 fw-medium" onClick={(e) => { e.preventDefault(); downloadFile('PRIVACY'); }}>
                                        <Link to={`#${terms.name}`} target="_blank">{terms.name}</Link>
                                    </td>
                                    <td>{convertToEST(terms.updatedAt)}</td>
                                    <td className='svg_style text-center pointer'>
                                        <DropdownButton
                                            variant="white"
                                            className="p-0 tableActionDropDown text-center"
                                            title={
                                                <div className="actionBtn">
                                                    {[...Array(3)].fill().map((_, index) => <span key={index}>
                                                        <i className="bi bi-three-dots-vertical"></i></span>)}
                                                </div>
                                            }
                                            drop="start"
                                        >
                                            <div className="bg-white">
                                                <Dropdown.Item
                                                    className="font14 fw-medium"
                                                    onClick={() => {
                                                        uploadFile('PRIVACY', `${terms.name}`)
                                                    }}
                                                    style={{borderBottom:"none"}}>
                                                    Upload
                                                </Dropdown.Item>
                                                <Dropdown.Item
                                                    className="font14 fw-medium"
                                                    onClick={() => {
                                                        downloadFile('PRIVACY')
                                                    }}
                                                >
                                                    Download
                                                </Dropdown.Item>
                                                <Dropdown.Item
                                                    className="font14 fw-medium"
                                                    onClick={() => {
                                                        deleteFile('PRIVACY', `${terms.name}`)
                                                    }}
                                                >
                                                    Delete
                                                </Dropdown.Item>
                                            </div>
                                        </DropdownButton>
                                    </td>
                                </tr>)}
                        </tbody>
                    </Table>
                </div>
                </div>
            </div>


            <div className="top_doc custom_table_settings mx-3">
    <div className="custom-container shadow-sm">
        
        <div className="d-flex justify-content-between mb-2 align-items-center">
            <h1 className=" text-dark font_style" style={{margin:'0px'}}>Notification</h1>
            <button className="btn btn-primaryTwo px-2" onClick={openNotificationModal}>Add Notification</button>
        </div>
                     {loader ? 
								<div className='d-flex justify-content-center align-items-center flex-column vh-50'>
								   <div className="spinner-border text-muted text-center"></div>
								</div>
							:
                            <div className="table-responsive"> 	 
        <Table className="table table_style unique">
            <thead className='bg-light-red font-14 static-header'>
                <th className="notification-type-column table-header">Notification Type</th>
                <th className="email-column table-header">Email</th>
                
                <th className="action-column table-header">Action</th>
            </thead>
            <tbody>
            {processedData && processedData.length > 0 ? (
                processedData.map((notification, index) => (
                    <tr key={index}>
                         
                         <td>{notification.type === 'ON_HOLD' ? "Low funds order" :
                        notification.type === 'NON_API' ? "Manual fulfillment" :
                        notification.type === 'OPEN' ? "Order open alert" :
                        notification.type === 'FUND_INVOICE' ? "Payment invoice" :
                        notification.type === 'QUICK_BOOK' ? "Order report": 
                        notification.type === 'INVENTORY_REPORT' ? "Inventory report":
                        notification.type === 'PENDING_APPROVAL' ? "Pending Approval":
                        notification.type === 'OUT_OF_STOCK' ? "Out of stock": 
                        notification.type === 'LOW_FUND_ALERT' && "Low fund alert" }</td>
                        <td>{notification?.email}</td>
                        
                        <td className="text-center">
                            <DropdownButton
                                variant="white"
                                className="p-0 tableActionDropDown text-center"
                                title={
                                    <div className="actionBtn">
                                        {[...Array(3)].fill().map((_, idx) => (
                                            <span key={idx}>
                                                <i className="bi bi-three-dots-vertical"></i>
                                            </span>
                                        ))}
                                    </div>
                                }
                                drop="start"
                            >
                                <div className="bg-white">
                                   
                                    <Dropdown.Item
                                        className="font14 fw-medium"
                                        onClick={() => {
                                           DeleteNotification(notification?.id,notification?.type)
                                        }}
                                    >
                                        Delete
                                    </Dropdown.Item>
                                </div>
                            </DropdownButton>
                        </td>
                    </tr>
                ))
            ) : (
                <tr>
                    <td colSpan="3" className="text-center">No data available</td>
                </tr>
            )}
            </tbody>
        </Table>
        </div>
}
    </div>
</div>

            <Modal
                show={uploadModal}
                onHide={closeUploadModal}
                backdrop="static"
                keyboard={false}
                size="md"
                centered
            >
                <Modal.Body>
                    <Col lg="12">
                        <div class="col-12">
                            <div class="d-flex flex-column align-items-center justify-content-center">
                                <h3 className="mb-4 upload_heading_text">Terms of Use</h3>
                                <div className="image_upload_card w-100">
                                    <label htmlFor="upload_file_terms pointer" className="w-100">
                                    <div className="w-50 mx-auto align">
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width={130}
                                            height={130}
                                            viewBox="0 0 77 77"
                                            fill="#FFAD31"
                                        >
                                            <mask
                                                id="mask0_697_226"
                                                style={{ maskType: "alpha" }}
                                                maskUnits="userSpaceOnUse"
                                                x={0}
                                                y={0}
                                                width={85}
                                                height={85}
                                            >
                                                <rect width="76.5083" height="76.5083" fill="#FFAD31" />
                                            </mask>
                                            <g mask="url(#mask0_697_226)">
                                                <path
                                                    d="M36.66 36.9179L31.0323 42.5273C30.7442 42.8257 30.384 42.9749 29.9518 42.9749C29.5195 42.9749 29.1481 42.8196 28.8375 42.509C28.4983 42.2106 28.3389 41.8346 28.3594 41.3809C28.3798 40.9272 28.5392 40.5512 28.8375 40.2529L36.4516 32.6388C36.9666 32.1239 37.5673 31.8664 38.2539 31.8664C38.9406 31.8664 39.5413 32.1239 40.0563 32.6388L47.6704 40.2529C47.9687 40.5512 48.1311 40.922 48.1577 41.3652C48.1843 41.8083 48.0218 42.191 47.6704 42.5133C47.372 42.8087 46.9991 42.9493 46.5515 42.935C46.104 42.9207 45.7249 42.7644 45.4143 42.466L39.8479 36.9179V55.4197C39.8479 55.9101 40.0522 56.3597 40.4609 56.7684C40.8696 57.1771 41.3192 57.3814 41.8096 57.3814H58.9749C61.2064 57.3814 63.0926 56.6111 64.6334 55.0703C66.1742 53.5295 66.9446 51.6433 66.9446 49.4118C66.9446 47.1803 66.1742 45.2942 64.6334 43.7534C63.0926 42.2126 61.2064 41.4422 58.9749 41.4422H54.1932V35.0665C54.1932 30.6567 52.6391 26.8977 49.531 23.7895C46.4228 20.6814 42.6638 19.1273 38.2539 19.1273C33.8441 19.1273 30.0851 20.6814 26.9769 23.7895C23.8688 26.8977 22.3147 30.6567 22.3147 35.0665H20.5982C17.6392 35.0665 15.0603 36.1557 12.8616 38.3341C10.6627 40.5124 9.56333 43.1424 9.56333 46.224C9.56333 49.3056 10.6525 51.9355 12.8309 54.1139C15.0092 56.2923 17.6392 57.3814 20.7208 57.3814H27.0965C27.5481 57.3814 27.9267 57.5344 28.2322 57.8403C28.5377 58.1463 28.6904 58.5253 28.6904 58.9775C28.6904 59.4298 28.5377 59.8081 28.2322 60.1126C27.9267 60.417 27.5481 60.5693 27.0965 60.5693H20.7208C16.7442 60.5693 13.3591 59.1864 10.5657 56.4206C7.77222 53.6547 6.37549 50.2743 6.37549 46.2791C6.37549 42.5028 7.67515 39.2291 10.2745 36.4581C12.8738 33.6872 15.9268 32.1975 19.4334 31.989C20.1486 27.3462 22.2841 23.5106 25.8398 20.4821C29.3954 17.4537 33.5335 15.9395 38.2539 15.9395C43.5822 15.9395 48.1021 17.7952 51.8137 21.5068C55.5252 25.2183 57.381 29.7383 57.381 35.0665V38.2544H59.3427C62.3957 38.3525 64.9573 39.4733 67.0274 41.6169C69.0974 43.7605 70.1324 46.3588 70.1324 49.4118C70.1324 52.5384 69.0749 55.1796 66.9599 57.3355C64.8449 59.4913 62.2241 60.5693 59.0975 60.5693H41.8096C40.3424 60.5693 39.1173 60.0778 38.1344 59.0949C37.1515 58.112 36.66 56.8869 36.66 55.4197V36.9179Z"
                                                    fill="#FFAD31"
                                                />
                                            </g>
                                        </svg>
                                    </div>
                                    </label>
                                    <input type="file" name="terms_document" id="upload_file_terms pointer" className="d-none" onChange={handleFileTerms} accept=".doc, .docx" />
                                    <div className="upload_down_btn d-flex align-items-center justify-content-center white-color">
                                        <button className="btn btn-primaryTwo position-relative px-4" onClick={uploadDocumentTerms}>
                                            Save</button>
                                        <button className="btn btn-primaryTwo position-relative px-4" onClick={() => {
                                            setFileName("")
                                            setSelectedFile("")
                                        }}>Clear</button>

                                    </div>
                                    <p className="mb-0 pdf_name w-100">filename:{fileName}</p>
                                </div>
                            </div>
                        </div>
                    </Col>
                </Modal.Body>
                <Modal.Footer>
                    <div>
                        <Button className="btn  bg-secondary" onClick={() => closeUploadModal()}>Close</Button>
                    </div>
                </Modal.Footer>
            </Modal>
            <Modal
                show={uploadModalTwo}
                onHide={closeUploadModalTwo}
                backdrop="static"
                keyboard={false}
                size="md"
                centered
            >
                <Modal.Body>
                    <Col lg="12">
                        <div class="col-12">
                            <div class="d-flex flex-column align-items-center justify-content-center">
                                <h3 className="mb-4 upload_heading_text">Privacy Policy</h3>
                                <div className="image_upload_card w-100">
                                    <label htmlFor="upload_file pointer" className="w-100">
                                    <div className="w-50 mx-auto align">
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width={130}
                                            height={130}
                                            viewBox="0 0 77 77"
                                            fill="#FFAD31"
                                        >
                                            <mask
                                                id="mask0_697_226"
                                                style={{ maskType: "alpha" }}
                                                maskUnits="userSpaceOnUse"
                                                x={0}
                                                y={0}
                                                width={85}
                                                height={85}
                                            >
                                                <rect width="76.5083" height="76.5083" fill="#FFAD31" />
                                            </mask>
                                            <g mask="url(#mask0_697_226)">
                                                <path
                                                    d="M36.66 36.9179L31.0323 42.5273C30.7442 42.8257 30.384 42.9749 29.9518 42.9749C29.5195 42.9749 29.1481 42.8196 28.8375 42.509C28.4983 42.2106 28.3389 41.8346 28.3594 41.3809C28.3798 40.9272 28.5392 40.5512 28.8375 40.2529L36.4516 32.6388C36.9666 32.1239 37.5673 31.8664 38.2539 31.8664C38.9406 31.8664 39.5413 32.1239 40.0563 32.6388L47.6704 40.2529C47.9687 40.5512 48.1311 40.922 48.1577 41.3652C48.1843 41.8083 48.0218 42.191 47.6704 42.5133C47.372 42.8087 46.9991 42.9493 46.5515 42.935C46.104 42.9207 45.7249 42.7644 45.4143 42.466L39.8479 36.9179V55.4197C39.8479 55.9101 40.0522 56.3597 40.4609 56.7684C40.8696 57.1771 41.3192 57.3814 41.8096 57.3814H58.9749C61.2064 57.3814 63.0926 56.6111 64.6334 55.0703C66.1742 53.5295 66.9446 51.6433 66.9446 49.4118C66.9446 47.1803 66.1742 45.2942 64.6334 43.7534C63.0926 42.2126 61.2064 41.4422 58.9749 41.4422H54.1932V35.0665C54.1932 30.6567 52.6391 26.8977 49.531 23.7895C46.4228 20.6814 42.6638 19.1273 38.2539 19.1273C33.8441 19.1273 30.0851 20.6814 26.9769 23.7895C23.8688 26.8977 22.3147 30.6567 22.3147 35.0665H20.5982C17.6392 35.0665 15.0603 36.1557 12.8616 38.3341C10.6627 40.5124 9.56333 43.1424 9.56333 46.224C9.56333 49.3056 10.6525 51.9355 12.8309 54.1139C15.0092 56.2923 17.6392 57.3814 20.7208 57.3814H27.0965C27.5481 57.3814 27.9267 57.5344 28.2322 57.8403C28.5377 58.1463 28.6904 58.5253 28.6904 58.9775C28.6904 59.4298 28.5377 59.8081 28.2322 60.1126C27.9267 60.417 27.5481 60.5693 27.0965 60.5693H20.7208C16.7442 60.5693 13.3591 59.1864 10.5657 56.4206C7.77222 53.6547 6.37549 50.2743 6.37549 46.2791C6.37549 42.5028 7.67515 39.2291 10.2745 36.4581C12.8738 33.6872 15.9268 32.1975 19.4334 31.989C20.1486 27.3462 22.2841 23.5106 25.8398 20.4821C29.3954 17.4537 33.5335 15.9395 38.2539 15.9395C43.5822 15.9395 48.1021 17.7952 51.8137 21.5068C55.5252 25.2183 57.381 29.7383 57.381 35.0665V38.2544H59.3427C62.3957 38.3525 64.9573 39.4733 67.0274 41.6169C69.0974 43.7605 70.1324 46.3588 70.1324 49.4118C70.1324 52.5384 69.0749 55.1796 66.9599 57.3355C64.8449 59.4913 62.2241 60.5693 59.0975 60.5693H41.8096C40.3424 60.5693 39.1173 60.0778 38.1344 59.0949C37.1515 58.112 36.66 56.8869 36.66 55.4197V36.9179Z"
                                                    fill="#FFAD31"
                                                />
                                            </g>
                                        </svg>
                                        </div>
                                    </label>
                                    <input type="file" name="privacy_document" id="upload_file pointer" className="d-none" onChange={handleFileprivacy} accept=".doc, .docx" />
                                    <div class="upload_down_btn d-flex align-items-center justify-content-center  white-text">
                                        <button class="btn btn-primaryTwo position-relative px-4" onClick={uploadDocumnetPrivacy}>
                                            Save</button>
                                        <button class="btn btn-primaryTwo position-relative px-4" onClick={() => {
                                            setFileNameTwo("");
                                            setSelectedFileTwo("")
                                        }}>Clear</button>
                                    </div>
                                    <p class="mb-0 pdf_name">filename:{fileNameTwo}</p>
                                </div>
                            </div>
                        </div>
                    </Col>
                </Modal.Body>
                <Modal.Footer>
                    <div>
                        <Button className="btn  bg-secondary" onClick={() => closeUploadModalTwo()}>Close</Button>
                    </div>
                </Modal.Footer>
            </Modal>

            <Modal
            show={notificationModal}
            onHide={closeNotificationModal}
            backdrop="static"
            keyboard={false}
            size="md"
            centered
        >
             <Modal.Header  className="custom_header_colourTwo modal-header" closeButton>
                <h6 style={{fontSize:"22px",fontWeight:"300",textTransform:"capitalize"}}>Add Notification</h6>
            </Modal.Header>
            <Modal.Body>
                <Col lg="12">
                    <Form>
                        <FormGroup className="mb-3" controlId="formNotification">
                            <Label style={{fontSize:"16px",fontWeight:"500"}}>Notification</Label>
                            <Select
                                value={selectedNotification}
                                onChange={handleNotificationChange}
                                options={notificationOptions}
                                placeholder="Select a notification"
                            />
                        </FormGroup>

                        <FormGroup className="mb-3" controlId="formEmail">
                            <Label style={{fontSize:"16px",fontWeight:"500"}}>Email</Label>
                            <Input
                                type="email"
                                placeholder="Enter email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                            />
                        </FormGroup>
                    </Form>
                </Col>
            </Modal.Body>
            <Modal.Footer style={{borderTop:"0px"}}>
            <Button  className="btn  bg-secondary" onClick={closeNotificationModal}>
                    cancel
                </Button>
                <button className="btn btn-primaryTwo" onClick={handleSubmit} disabled={addNotiLoad}>
                    {!addNotiLoad && "Submit"}{addNotiLoad && <Spinner
        as="span"
        animation="border"
        size="sm"
        role="status"
        aria-hidden="true"
        style={{
          margin: "0px 8px"
        }}
      />}
                </button>
            </Modal.Footer>
        </Modal>
        <Modal show={warningModal} onHide={toggleWarning} backdrop="static">
            <Modal.Header className="bg-warning" closeButton>Access Denied</Modal.Header>
            <Modal.Body>
                <p className="card-just-text">
				You do not have access to perform this action
                </p>
            </Modal.Body>
            <Modal.Footer>
                <Button className="btn  bg-secondary" onClick={toggleWarning}>Close</Button>
            </Modal.Footer>
        </Modal>
        </>
    )
}
export default Setting;
